import React, { useState } from "react";

// importing styles
import "./header-section-styles.scss";

// importing components
import LogoComponent from "../../components/logo-component/logo-component";
import NavListComponent from "../../components/nav-list-component/nav-list-component";
import ThemeComponent from "../../components/theme-component/theme-component";
import EmailComponent from "../../components/email-component/email-component";
import SocialIconsBoxComponent from "../../components/social-icons-box-component/social-icons-box-component";

const HeaderSection = () => {
	const [offCanvas, setOffCanvas] = useState(false);

	return (
		<header id="header-section" className="header-section">
			<div className="header-section-content-wrapper">
				{/* logo */}
				<LogoComponent />

				{window.innerWidth > 830 ? (
					<>
						{/* navigation */}
						<NavListComponent />
						{/* theme */}
						{/* <ThemeComponent /> */}
						{/* email */}
						<EmailComponent />
						{/* social icons */}
						<SocialIconsBoxComponent />
					</>
				) : (
					<>
						<div className="off-canvas-icon-box__icon">
							<img
								onClick={() => setOffCanvas(() => !offCanvas)}
								src={require("../../assets/open-icon.png")}
								alt=""
								className="open-off-canvas-icon off-canvas-icon"
							/>
						</div>
						<div
							className={`header-section-content-wrapper__tablet-menu ${
								offCanvas ? `open` : ``
							} `}
						>
							<img
								onClick={() => setOffCanvas(() => !offCanvas)}
								src={require("../../assets/close-icon.png")}
								alt=""
								className="close-off-canvas-icon off-canvas-icon"
							/>
							{/* navigation */}
							<NavListComponent />
							{/* theme */}
							{/* <ThemeComponent /> */}
							{/* email */}
							<EmailComponent />
							{/* social icons */}
							<SocialIconsBoxComponent />
						</div>
					</>
				)}
			</div>
		</header>
	);
};

export default HeaderSection;
